/// <reference lib="es2022.intl" />

/** Segment plain response text without changing decimal, URL or inline-markdown tokens. */
export function sentenceSegments(text: string): string[] {
  const value = text.trim();
  if (!value) return [];
  // Older embedded browsers can keep a single paragraph rather than guess boundaries.
  if (typeof Intl.Segmenter !== "function") return [value];

  const inlineRanges = Array.from(
    value.matchAll(/\[[^\]\n]+\]\(https?:\/\/[^\s)]+\)|\*\*[^\n]+?\*\*|https?:\/\/\S+/g),
    match => ({ start: match.index!, end: match.index! + match[0].length }),
  );
  const sentences: string[] = [];
  let start = 0;
  for (const segment of new Intl.Segmenter("en", { granularity: "sentence" }).segment(value)) {
    const end = segment.index + segment.segment.length;
    // A sentence boundary within a link label or bold span must not break its markup.
    if (inlineRanges.some(range => end > range.start && end < range.end)) continue;
    const sentence = value.slice(start, end).trim();
    if (sentence) sentences.push(sentence);
    start = end;
  }
  return sentences;
}
